import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./pharmaceutical.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const Pharmaceutical = () => {
  return (
    <div className="pharmaceutical-industry-wrapper">
      <Particles title="Pharmaceutical" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default Pharmaceutical;
